<div>
  <table class="pricing-table" style="width:100%;">
    <tr>
      <th>Item</th>
      <th>Estimated Lead Time*</th>
      <th style="text-align:center;">HTS Code</th>
      <th style="text-align:center;">Country of Origin</th>
      <th style="text-align:center;">List Price</th>
      <th style="text-align:center;">Discount</th>
      <th style="text-align:center;">Your Price Each</th>
      <th style="text-align:center;">Quantity</th>
      <th style="text-align:center;">Total{{ShowTariffMessage ? "**" : ""}}</th>
      <th></th>
    </tr>
    <ng-container *ngFor="let item of ItemPriceList">
      <tr>
        <td class="small-content">
          <span class="popup-sub-header" [ngClass]="{'red': item.ConfigHasChanged }">{{item.Item}}</span>
          <br />
          <ng-container>
            <span class="small-content">{{item.EffectivePricing.Description}}</span>
            <br />
          </ng-container>
          <ng-container *ngIf="item.Description2 != null && item.Description2.length > 0">
            <span class="small-content" [innerHtml]="item.Description2"></span>
            <br />
          </ng-container>
          <ng-container *ngIf="item.SelectionSummary != null && item.SelectionSummary.length > 0">
            <span class="small-content" [innerHtml]="item.SelectionSummary"></span>            
            <br />
          </ng-container>
          <ng-container *ngIf="item.SelectionSummary == null || item.SelectionSummary.length == 0">
            <span [hidden]="!item.EffectivePricing.CrateRequiredFlag" style="color:red;">
              Note: Due to the weight or length of this actuator it cannot ship regular ground service and a CRATE may be required. Consult <a href="mailto:customercare@tolomatic.com">customercare&#64;tolomatic.com</a> with any questions.
            </span>
            <br />
          </ng-container>
          <!--Effective Price-->
          <ng-container *ngIf="(item.EffectivePricing.PortalPricingEnabled || item.EffectivePricing.ActiveForCustomerPortal || OverridePricingRule) && item.EffectivePricing.ItemStatus != 'O'">
            <ng-container *ngIf="item.EffectivePricing.BreakQty1 >= 1">
              <span class="medium-content font-weight-bold">Pricing Matrix</span>
              <br />
              <span>Qty:{{item.EffectivePricing.BreakQty1}} Price = {{(item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice1 / 100.00) * item.EffectivePricing.UnitPrice)) | currency}}</span>
              <br />
            </ng-container>
            <ng-container *ngIf="item.EffectivePricing.BreakQty2 >= 1">
              <span>Qty:{{item.EffectivePricing.BreakQty2}} Price = {{(item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice2 / 100.00) * item.EffectivePricing.UnitPrice)) | currency}}</span>
              <br />
            </ng-container>
            <ng-container *ngIf="item.EffectivePricing.BreakQty3 >= 1">
              <span>Qty:{{item.EffectivePricing.BreakQty3}} Price = {{(item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice3 / 100.00) * item.EffectivePricing.UnitPrice)) | currency}}</span>
              <br />
            </ng-container>
            <ng-container *ngIf="item.EffectivePricing.BreakQty4 >= 1">
              <span>Qty:{{item.EffectivePricing.BreakQty4}} Price = {{(item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice4 / 100.00) * item.EffectivePricing.UnitPrice)) | currency}}</span>
              <br />
            </ng-container>
            <ng-container *ngIf="item.EffectivePricing.BreakQty5 >= 1">
              <span>Qty:{{item.EffectivePricing.BreakQty5}} Price = {{(item.EffectivePricing.UnitPrice + ((item.EffectivePricing.BreakPrice5 / 100.00) * item.EffectivePricing.UnitPrice)) | currency}}</span>
              <br />
            </ng-container>
          </ng-container>
          <br />
          <span class="clickable blue-color" (click)="ViewItemDetails(item)">View Details</span>
        </td>
        <td style="text-align:center;">{{item.EffectivePricing.ItemStatus != 'O' ? item.EffectivePricing.EstimatedLeadTime : ""}}
          <br />
          {{item.EffectivePricing.ItemStatus != 'O' && item.EffectivePricing.InventoryItem ? GetInStockString(item.EffectivePricing.QtyAvailable) : item.EffectivePricing.ItemStatus != "O" && !item.EffectivePricing.InventoryItem ? "Built to Order" : ""}}
        </td>
        <td style="text-align:center;">{{item.EffectivePricing.HTSCode}}</td>
        <td style="text-align:center;">{{item.EffectivePricing.Country}}</td>
        <ng-container *ngIf="item.HasPricing && (item.EffectivePricing.PortalPricingEnabled || item.EffectivePricing.ActiveForCustomerPortal || OverridePricingRule) && item.EffectivePricing.ItemStatus != 'O'">
          <td style="text-align:center;">{{item.EffectivePricing.UnitPrice | currency:'USD':'symbol-narrow':'1.2-2'}}</td>
          <td style="text-align:center;">{{GetDiscount(item)}}</td>
          <td style="text-align:center;">{{GetDistPrice(item) | currency:'USD':'symbol-narrow':'1.2-2'}}</td>
          <td style="text-align:center;"><input type="number" [(ngModel)]="item.Quantity" min="0" /></td>
          <td style="text-align:center;">{{(item.Quantity * GetDistPrice(item)) | currency:'USD':'symbol-narrow':'1.2-2'}}</td>
          <td><fa-icon [icon]="faXmark" (click)="RemoveItem(item.Index)" class="clickable blue-color"></fa-icon></td>
        </ng-container>
        <ng-container *ngIf="item.HasPricing == false && OverridePricingRule">
          <td colspan="5" style="text-align:center;">Please contact Tolomatic customer service for assistance.</td>
          <td><fa-icon [icon]="faXmark" (click)="RemoveItem(item.Index)" class="clickable blue-color"></fa-icon></td>
        </ng-container>
        <ng-container *ngIf="!item.EffectivePricing.PortalPricingEnabled && !item.EffectivePricing.ActiveForCustomerPortal && !OverridePricingRule && item.EffectivePricing.ItemStatus != 'O'">
          <td colspan="5" style="text-align:center;">This item is a special. Please contact Tolomatic customer service for assistance.  </td>
          <td><fa-icon [icon]="faXmark" (click)="RemoveItem(item.Index)" class="clickable blue-color"></fa-icon></td>
          <!--<td style="text-align:center;"></td>
  <td style="text-align:center;"><input type="number" [(ngModel)]="item.Quantity" min="0" /></td>
  <td style="text-align:center;"></td>-->

        </ng-container>
        <ng-container *ngIf="item.EffectivePricing.ItemStatus == 'O'">
          <td colspan="5" style="text-align:center;">This item is obsolete. Please contact Tolomatic customer service for assistance.  </td>
          <td><fa-icon [icon]="faXmark" (click)="RemoveItem(item.Index)" class="clickable blue-color"></fa-icon></td>
          <!--<td style="text-align:center;"></td>
  <td style="text-align:center;"><input type="number" [(ngModel)]="item.Quantity" min="0" /></td>
  <td style="text-align:center;"></td>-->
        </ng-container>

        
      </tr>
    </ng-container>
  </table>
  <br />
  <div [hidden]="!ShowTariffMessage" [innerHTML]="TariffVerbiage"></div>
  <br />
  <div [innerHTML]="EstLeadTimeVerbiage">
    <!--<span>*Estimated Lead Times are updated regularly as a guideline for expected lead time only. Actual lead time can vary based on quantity, component availability, and timing of order placement.  If your customer has a requirement for a shorter lead time and interested in exploring faster options that include an expedite fee (30% of list price or $50 minimum). Please confirm the customer is willing to pay the expedite fee. If so, contact your Sales Support Specialist to confirm our availability to expedite. </span>-->
    <!--Estimated Lead Times are provided as a general guide and may vary based on quantity and component availability. If your customer needs a shorter lead time, expedited options may be available with an additional fee (30% of list price or $50 minimum). Please send your PO, including the expedite fee and expedited shipping method, to <a href="mailto:orders@tolomatic.com">orders@tolomatic.com</a>. Please contact your Sales Support Specialist or <a href="mailto:customercare@tolomatic.com">customercare@tolomatic.com</a> with your expedite questions.-->
    
  </div>
  <!--<div class="row-no-margin">
    <span>{{Item}}</span>
  </div>-->
  <div>
    
  </div>
</div>
